export enum MissionType {
    LinkTwitter = 'LinkTwitter',
    FollowTwitterAccount = 'FollowTwitterAccount',
    TwitterPostInteraction = 'TwitterPostInteraction',
    TwitterPostLike = 'TwitterPostLike',
    TwitterPostRetweet = 'TwitterPostRetweet',
    TwitterPostComment = 'TwitterPostComment',
    FreeMintNFTPiece = 'FreeMintNFTPiece',
}

export enum Status {
    NotStart = 'NotStart',
    InProgress = 'InProgress',
    Completed = 'Completed',
    Duplicated = 'Duplicated', // 换绑过地址
}

export type UserMission = {
    description: string;
    endDate: string | null;
    gec: string;
    id: string;
    isInProgress: boolean;
    link: string | null;
    name: string;
    point: string;
    startDate: string;
    type: MissionType;
    status: Status;
    details?: {
        address: string;
        completedAt: string | null;
        historyId: string;
        twitterName: string;
    };
};
